import React from 'react';
import styled from "styled-components";
import ImgSlider from "./ImgSlider";
import Viewer from "./Viewer";
import Recommends from "./Recommends";
import NewDisney from "./NewDisney";
import Originals from "./Originals";
import Trending from "./Trending";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setMovies} from "../features/movieSlice";
import {selectUserName} from "../features/userSlice";
import {getDocs, collection} from "../firebase";
import db from "../firebase"

function Home(props) {
    const dispatch = useDispatch();
    const username = useSelector(selectUserName);
    let recommend = [];
    let newDisney = [];
    let original = [];
    let trending = [];
    let loaded = false;

    useEffect(() => {
        if(!loaded){
            getDocs(collection(db, "movies")).then(res =>{
                const docs = res.docs
                docs.map(doc => {
                    switch (doc.data().type){
                        case "recommend":
                            recommend = [...recommend, {id: doc.data().itemID, ...doc.data()}];
                            break;
                        case "new":
                            newDisney = [...newDisney, {id: doc.data().itemID, ...doc.data()}];
                            break;
                        case "original":
                            original = [...original, {id: doc.data().itemID, ...doc.data()}];
                            break;
                        case "trending":
                            trending = [...trending, {id: doc.data().itemID, ...doc.data()}];
                            break;
                    }
                })

                dispatch(setMovies ({
                    recommend,
                    newDisney,
                    original,
                    trending
                }))
            })
            loaded = true;
        }


    }, [username])


    return (
        <Container>
            <ImgSlider />
            <Viewer />
            <Recommends />
            <NewDisney />
            <Originals />
            <Trending />
        </Container>
    );
}

const Container = styled.main`
    position: relative;
    background-image: url("./images/home-background.png");
    min-height: calc(100vh - 250px);
    display: block;
    overflow-x: hidden;
    top: 72px;
    padding: 0 calc(3.5rem + 5px);
    // overflow: hidden;
    
    &:after{
        background-image: url("./images/home-background.png") center center / cover no-repeat fixed;
        content: "";
        inset: 0px;
        position: absolute;
        opacity: 1;
        z-index: -1;
    }
    
`

export default Home;